import { IEnvironment, IAuth0Settings } from "@/typings/interfaces/environment.interface";

export const environment: () => IEnvironment = () => (window as any).__app__.$store.state.environment;
export const apiBaseUrl: () => string = (): string => environment().apiBaseUrl;
export const envName: () => string = (): string => environment().envName;
export const auth0: () => IAuth0Settings = (): IAuth0Settings => environment().auth0;
export const TTINTUrl: () => string = (): string => environment().TTINTUrl;